import React, { useEffect, useState } from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import FormUsuario from "../../components/usuarios/FormUsuario";
import Loader from "../../components/Loader";
import { useParams, useNavigate } from 'react-router-dom';
import { formSchema } from "../../validaciones/validacionUsuarios";
import { apiFetch } from "../../utils/api";

const ROLES_CMS_PERMITIDOS = [20, 21, 22];

const opcionesPerfilFallback = [
  { value: 20, label: 'Administrador CMS' },
  { value: 21, label: 'Gestor CMS' },
  { value: 22, label: 'Instructor' },
];

const SECTION_PERMISSIONS = {
  1: { read: 'branches:read', write: 'branches:write' },
  2: { read: 'users:read', write: 'users:write' },
  3: { read: 'dishes:read', write: 'dishes:write' },
  4: { read: 'promotions:read', write: 'promotions:write' },
  5: { read: 'notifications:read', write: 'notifications:write' },
  6: { read: 'users:read', write: 'users:write' },
  8: { read: 'dishes:read', write: 'dishes:write' },
  9: { read: 'reservations:read', write: 'reservations:write' },
  10: { read: 'notifications:read', write: 'notifications:write' },
  11: { read: 'tournaments:read', write: 'tournaments:write' },
  12: { read: 'courts:read', write: 'courts:write' },
  13: { read: 'reservations:read', write: 'reservations:write' },
  14: { read: 'reservations:read', write: 'reservations:write' },
  15: { read: 'reservations:read', write: 'reservations:write' },
};

const permisosDesdeSecciones = (secciones) => {
  const permisos = new Set(['cms:access']);
  secciones.forEach((seccion) => {
    const config = SECTION_PERMISSIONS[seccion.value];
    if (!config) return;
    if (seccion.esVer && config.read) {
      permisos.add(config.read);
      permisos.add(`cms:section:${seccion.value}:read`);
    }
    if (seccion.esCrear) permisos.add(`cms:section:${seccion.value}:create`);
    if (seccion.esEditar) permisos.add(`cms:section:${seccion.value}:update`);
    if (seccion.esEliminar) permisos.add(`cms:section:${seccion.value}:delete`);
    if ((seccion.esCrear || seccion.esEditar || seccion.esEliminar) && config.write) permisos.add(config.write);
  });
  return Array.from(permisos);
};

const aplicarPermisosASecciones = (secciones, permisos = [], esAdmin = false) => {
  const permisosSet = new Set(permisos);
  return secciones.map((seccion) => {
    const config = SECTION_PERMISSIONS[seccion.value];
    if (!config) return seccion;
    const hasUiFlags = ['read', 'create', 'update', 'delete']
      .some((action) => permisosSet.has(`cms:section:${seccion.value}:${action}`));
    const hasRead = esAdmin || (hasUiFlags
      ? permisosSet.has(`cms:section:${seccion.value}:read`)
      : permisosSet.has(config.read));
    const hasWrite = esAdmin || Boolean(config.write && permisosSet.has(config.write));
    return {
      ...seccion,
      esVer: hasRead,
      esCrear: hasUiFlags ? permisosSet.has(`cms:section:${seccion.value}:create`) : hasWrite,
      esEditar: hasUiFlags ? permisosSet.has(`cms:section:${seccion.value}:update`) : hasWrite,
      esEliminar: hasUiFlags ? permisosSet.has(`cms:section:${seccion.value}:delete`) : hasWrite,
    };
  });
};

const DetalleUsuarioPage = () => {
  const [error, setError] = useState(null);
  const [tipo_usuario, setTipo_usuario] = useState([])
  const [sucursales, setSucursales] = useState([])
  const [sucursalesUsuario, setSucursalesUsuario] = useState([])
  const [secciones, setSecciones] = useState([])
  const [isLoading, setIsLoading] = useState({cargarSucursalPermiso: true, cargarUsuario: true});
  const navigate = useNavigate();
  const { id } = useParams();

  const [datos, setDatos] = useState({
    id,
    nombre:"",
    apellido_paterno:"",
    apellido_materno:"",
    correo:"",
    telefono:"",
    pais_telefono:"",
    esValidoTelefono:false,
    contra:"",
    foto:"",
    tipo:21,
    estatus:1
  })

  const mapSucursal = (item) => ({
    value: item.id || item.ID_SUC,
    label: item.nombre || item.NOMBRE_SUCURSAL_SUC || item.label,
  });

  const mapPerfil = (item) => ({
    value: item.id || item.VALOR_TIPO,
    label: item.name || item.NOMBRE_TIPO || item.label,
  });

  const mapSeccion = (item) => ({
    value: item.ID_SEC,
    label: item.NOMBRE_SEC,
    esVer: Boolean(item.CONSULTAR_PER ?? true),
    esCrear: Boolean(item.CREAR_PER ?? true),
    esEditar: Boolean(item.ACTUALIZAR_PER ?? true),
    esEliminar: Boolean(item.BORRAR_PER ?? true),
  });

  const crearPayloadUsuario = () => {
    const payload = {
      nombre: datos.nombre.trim(),
      apellido: [datos.apellido_paterno, datos.apellido_materno].filter(Boolean).join(' ').trim(),
      email: datos.correo.trim(),
      telefono: datos.telefono.replace(/\D/g, ''),
      profileId: Number(datos.tipo),
      branchIds: sucursalesUsuario.map((item) => item.value),
      activo: Number(datos.estatus) === 1,
    };

    if (Number(datos.tipo) === 21) {
      payload.permissions = permisosDesdeSecciones(secciones);
    }

    return payload;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    // console.log(name, value);
    setDatos({ ...datos, [name]: value });
  };

  const handlePermisos = (item,valor) => {
    let seccionesArray = [...secciones];
    seccionesArray[item] = valor;
    setSecciones(seccionesArray);
  };

  const handleSucursal = (e) => {
    setSucursalesUsuario(e);
  }

  function onChangeValidity(phoneNumber) {
    if (datos.esValidoTelefono !== phoneNumber) {
      setDatos(x => ({...x, esValidoTelefono: phoneNumber}));
    }
  }

  function onChangePhone(phoneNumber) {
    if(datos.telefono !== phoneNumber){
      setDatos(x => ({...x, telefono: phoneNumber}));
    }
  }

  function onChangeCountry (country) {
    if(datos.pais_telefono !== country){
      setDatos(x => ({...x, pais_telefono: country}));
    }
  }

  useEffect(() => {
    async function obtenerCatalogos() {
      const [perfilesResult, sucursalesResult, seccionesResult] = await Promise.allSettled([
        apiFetch("/api/profiles"),
        apiFetch("/api/branches"),
        apiFetch("/api/secciones"),
      ]);

      const perfilesData = perfilesResult.status === 'fulfilled' && perfilesResult.value.status
        ? perfilesResult.value.data
            .map(mapPerfil)
            .filter((item) => ROLES_CMS_PERMITIDOS.includes(Number(item.value)))
        : opcionesPerfilFallback;
      setTipo_usuario(perfilesData.length ? perfilesData : opcionesPerfilFallback);

      const sucursalesData = sucursalesResult.status === 'fulfilled' && sucursalesResult.value.status
        ? sucursalesResult.value.data.map(mapSucursal)
        : [];
      setSucursales(sucursalesData);

      const seccionesArray = seccionesResult.status === 'fulfilled' && seccionesResult.value.status
        ? seccionesResult.value.data.map(mapSeccion)
        : [];
      setSecciones(seccionesArray);
      setIsLoading(x => ({...x, cargarSucursalPermiso: false}));
      obtenerUsuario(seccionesArray, sucursalesData);
    }

    function obtenerUsuario(seccionesArray, sucursalesData) {
      // eslint-disable-next-line
      if(id !== "0"){
        apiFetch(`/api/users/${id}`,{
          method: "GET",
        })
        .then((data) => {
          if(data.status){
            console.log(data);
            const usuario = data.data;
            const apellidoParts = (usuario.apellido || '').split(' ');
            const profileIdNum = Number(usuario.profileId);
            const tipoResolved = ROLES_CMS_PERMITIDOS.includes(profileIdNum) ? profileIdNum : 21;
            setDatos((x)=>({
              ...x,
              id,
              nombre:usuario.nombre || "",
              apellido_paterno:apellidoParts.shift() || "",
              apellido_materno:apellidoParts.join(' ') || "",
              correo:usuario.email || "",
              telefono:usuario.telefono || "",
              pais_telefono:"",
              tipo: tipoResolved,
              estatus:usuario.activo ? 1 : 2
            }));
            setSucursalesUsuario((usuario.branchIds || [])
              .map((branchId) => sucursalesData.find((item) => item.value === branchId))
              .filter(Boolean));

            setSecciones(aplicarPermisosASecciones(
              seccionesArray,
              usuario.profile?.permissions || [],
              Number(usuario.profileId) === 20
            ));
          } 
        })
        .finally(() => setIsLoading(x => ({...x, cargarUsuario: false})));
      }
      else{
        setIsLoading(x => ({...x, cargarUsuario: false}));
      }
    }

    obtenerCatalogos();
  }, [id]);

  const handleSave = () => {
    const result = formSchema.safeParse({...datos, telefono: datos.telefono.replace(/\D/g, ''),sucursales:sucursalesUsuario});
    if (!result.success) {
      console.log(result.error.errors);
      console.log(result.error.flatten().fieldErrors);
      setError(result.error.flatten().fieldErrors)
      return;
    }
    // eslint-disable-next-line
    if (id === "0") {
      // Create new sucursal
      try {
        apiFetch("/api/users",{
          method: "POST",
          body: JSON.stringify(crearPayloadUsuario())
        })
        .then((data) => {
          console.log(data);

          if(data.status){
            // Success
            navigate(-1);
          }
          else{
            window.notie.alert({ type: 'warning', text: data.message || 'No se pudo crear el usuario' });
          }
        });
      } catch (error) {
        console.error('Error:', error);
      }
    }
    else {
      console.log('secciones', secciones);
      
      // Update sucursal
      try {
        apiFetch(`/api/users/${id}`,{
          method: "PUT",
          body: JSON.stringify(crearPayloadUsuario())
        })
        .then((data) => {
          console.log(data);
          if(data.status){
            // Success
            navigate(-1);
          } else {
            window.notie.alert({ type: 'warning', text: data.message || 'No se pudo actualizar el usuario' });
          }
        });
      } catch (error) {
        console.error('Error:', error);
      }
    }
  }

  return (
    <>
      <MasterLayout>
        { (isLoading.cargarSucursalPermiso || isLoading.cargarUsuario) ? 
          <Loader /> : 
          <FormUsuario 
            datos={datos} 
            handleChange={handleChange} 
            handleSave={handleSave}
            tipo_usuario={tipo_usuario} 
            sucursales={sucursales} 
            secciones={secciones} 
            sucursalesUsuario={sucursalesUsuario}
            handlePermisos={handlePermisos}
            handleSucursal={handleSucursal}
            onChangeValidity={onChangeValidity}
            onChangePhone={onChangePhone}
            onChangeCountry={onChangeCountry}
            error={error}
          />
        }
      </MasterLayout>
    </>
  );
};

export default DetalleUsuarioPage;
